export default __webpack_public_path__ + "static/media/guia-6-3.33532774.svg";